import PropTypes, { element } from 'prop-types';
import React from 'react';
import { InputWrapper } from '@amzn/stencil-react-components/input';
import { Select } from '@amzn/stencil-react-components/select';

const MultiSelectInput = ({
  elementId,
  options,
  values,
  onChangeHandler,
  filterOptions,
  disabled,
}) => {
  return (
    <InputWrapper id={elementId}>
      {inputProps => (
        <Select
          data-testid={elementId}
          isMulti={true}
          disabled={disabled}
          options={options}
          value={values}
          isSearchable={true}
          onChange={onChangeHandler}
          filterOptions={filterOptions}
          {...inputProps}
        />
      )}
    </InputWrapper>
  );
};

MultiSelectInput.propTypes = {
  elementId: PropTypes.string.isRequired,
  options: PropTypes.func.isRequired,
  values: PropTypes.string.isRequired,
  onChangeHandler: PropTypes.func.isRequired,
};

export default MultiSelectInput;
